import { apiClient } from './apiClient';

const Details = (orderId: string) =>
  apiClient(`/retailer_app.api.retailer.get_order_summary?order_id=${orderId}`, 'GET');

const History = (customerId: string, limitStart: any, limitPageLen: any) =>
  apiClient(
    `/retailer_app.api.retailer.websiteorder_history_of_customer?customer_id=${customerId}&limit_start=${limitStart}&limit_page_length=${limitPageLen}`,
    'GET'
  );

export const OrdersService = {
  Details,
  History,
};
